import api from './api';

const usuarioService = {
  listarUsuarios: async (estado = 'activos') => {
    const { data } = await api.get('/auth/usuarios', { params: { estado } });
    return data.usuarios ?? data;
  },

  obtenerUsuario: async (id) => {
    const { data } = await api.get(`/auth/usuarios/${id}`);
    return data.usuario ?? data;
  },

  actualizarUsuario: async (id, payload) => {
    const { data } = await api.put(`/auth/usuarios/${id}`, payload);
    return data;
  },

  desactivarUsuario: async (id) => {
    const { data } = await api.delete(`/auth/usuarios/${id}`);
    return data;
  },

  reactivarUsuario: async (id) => {
    const { data } = await api.post(`/auth/usuarios/${id}/restaurar`);
    return data;
  },

  /** @deprecated use desactivarUsuario */
  eliminarUsuario: async (id) => usuarioService.desactivarUsuario(id),
};

export default usuarioService;
